import {
    createSubPlayTemplateView,
    showVideoTemplateLegacy,
    hideVideoTemplateLegacy,
    preloadSubPlayTemplateView, closeSubPlayTemplateView, appendSubPlayTemplateView, appendSubView
} from '../../api'
import Webview from "../operationalComponent/Webview";
import Template from "./Template";

export default class VideoTemplateLegacy extends Template {
    constructor(props) {
        super(props);

        this.unitId = props.unitId
        this.unitSetting = props.unitSetting
    }

    init() {

    }

    /**
     * 创建一个 ViewType 为 4 的原生播放模板视图
     * @param campaign
     * @returns {Promise<any>}
     */
    create({campaign}) {
        let unitId = this.unitId
        let unitSetting = this.unitSetting
        let sdkSetting = this.sdkSetting
        return createSubPlayTemplateView({campaign, unitId, unitSetting, sdkSetting})
    }

    preload ({id}) {
        let unitId = this.unitId
        return preloadSubPlayTemplateView({unitId, id})
    }

    append ({parentCmptId, childCmptId, rect}) {
        let unitId = this.unitId
        return appendSubView({unitId, parentCmptId, childCmptId, rect})
        // TODO 暂时调用通用的 appendSubView  之后依然需要换成 appendSubPlayTemplateView
        // return appendSubPlayTemplateView({unitId, parentCmptId, childCmptId, rect})
    }

    // show(instanceId) {
    //     // AOP showsuccess 开发者回调
    //     return showVideoTemplateLegacy(instanceId)
    // }
    //
    // hide(instanceId) {
    //     return hideVideoTemplateLegacy(instanceId)
    // }

    close({id}) {
        let unitId = this.unitId
        return closeSubPlayTemplateView({unitId, id})
    }

}